module.exports = __webpack_public_path__ + "static/media/evier.8ba78ab4.svg";